import utils from 'helpers/utils'
import colors from 'helpers/colors';
import lightColors from 'whiteLabels/dealsuite/theme/colors/light.json';
import {desaturate, lighten} from 'polished';

const palette = colors.createPalette(lightColors);

const themeOverrides = {
  palette: {
    ...palette,
    menuButton: {
      states: {
        defaultText: (theme) => desaturate(0.1, lighten(0.15, theme.property('palette.secondary.main')))
      }
    },
  }
};

export default function factory (overrides) {
  return utils.mergeObjects(overrides, themeOverrides, true);
}
